import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";
import PortalProtectedRoute from "@/components/PortalProtectedRoute";
import { AuthProvider } from "@/lib/AuthContext";
import { PortalAuthProvider } from "@/lib/PortalAuthContext";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Locations from "@/pages/Locations";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import EmailSignature from "@/pages/EmailSignature";
import AdminDocuments from "@/pages/AdminDocuments";
import AdminPassword from "@/pages/AdminPassword";
import AdminFleet from "@/pages/AdminFleet";
import AdminTolls from "@/pages/AdminTolls";
import AdminMaintenance from "@/pages/AdminMaintenance";
import AdminFleetMap from "@/pages/AdminFleetMap";
import AdminGeofences from "@/pages/AdminGeofences";
import AdminIdentity from "@/pages/AdminIdentity";
import AdminDigest from "@/pages/AdminDigest";
import PortalLogin from "@/pages/PortalLogin";
import PortalVerify from "@/pages/PortalVerify";
import Portal from "@/pages/Portal";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
      <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
      <Route path="/locations" element={<PublicLayout><Locations /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/apply" element={<PublicLayout><Apply /></PublicLayout>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/signature"
        element={
          <ProtectedRoute>
            <EmailSignature />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/documents"
        element={
          <ProtectedRoute>
            <AdminDocuments />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/password"
        element={
          <ProtectedRoute>
            <AdminPassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/fleet"
        element={
          <ProtectedRoute>
            <AdminFleet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/tolls"
        element={
          <ProtectedRoute>
            <AdminTolls />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/maintenance"
        element={
          <ProtectedRoute>
            <AdminMaintenance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/fleet-map"
        element={
          <ProtectedRoute>
            <AdminFleetMap />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/geofences"
        element={
          <ProtectedRoute>
            <AdminGeofences />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/identity"
        element={
          <ProtectedRoute>
            <AdminIdentity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/digest"
        element={
          <ProtectedRoute>
            <AdminDigest />
          </ProtectedRoute>
        }
      />
      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal/verify" element={<PortalVerify />} />
      <Route
        path="/portal"
        element={
          <PortalProtectedRoute>
            <Portal />
          </PortalProtectedRoute>
        }
      />
      <Route
        path="/portal/payments"
        element={
          <PortalProtectedRoute>
            <Portal />
          </PortalProtectedRoute>
        }
      />
      <Route
        path="/portal/tolls"
        element={
          <PortalProtectedRoute>
            <Portal />
          </PortalProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <PortalAuthProvider>
            <ScrollToTop />
            <AppRoutes />
            <Toaster
              position="top-right"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#111111",
                  color: "#ffffff",
                  border: "1px solid rgba(212,175,55,0.3)",
                },
              }}
            />
          </PortalAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
